import type { Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

export const styles = {
  accordionItem: (isActive: boolean) => (): SystemStyleObject<Theme> => ({
    overflow: isActive ? 'auto' : undefined,
    display: 'flex',
    flexFlow: 'column',

    '&:active, &:focus': {
      outline: 'none',
    },
  }),
};
